export default "__VITE_ASSET__SK61Dy2C__"